module.exports = __webpack_public_path__ + "static/media/image-upload-text-gray.a63c81ff.svg";